class CharmPopup extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('.add-charms');
        this.button.addEventListener('click', this.onSubmitHandler.bind(this));
        this.currencyFormat = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        });

        this.closeButton = document.querySelector('.charm-modal-popup .product-popup-modal__toggle');
        this.parent = this.closest('modal-dialog');
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        const charms = this.querySelectorAll('input[type="checkbox"]:checked');
        const parentElement = document.querySelector('charms');
        parentElement.textContent = '';
        if (charms.length) {
            charms?.forEach(charm => {
                const wrapper = document.createElement('div');
                wrapper.className = 'charm-xs-wrapper';
                const img = document.createElement('img');
                img.src = charm.dataset.thumbnail;
                img.className = 'charm-thumbnail';
                wrapper.appendChild(img);
                const text = document.createElement('div');
                text.className = 'charm-info';
                const title = document.createElement('h3');
                title.innerText = charm.dataset.title;
                const priceWrapper = document.createElement('div');
                priceWrapper.className = 'price-wrapper';
                const price = document.createElement('div');
                price.innerText = this.currencyFormat.format(charm.dataset.price / 100);
                price.className = 'price';
                priceWrapper.appendChild(price);
                const modal = document.createElement('modal-opener');
                modal.classList.add('product-popup-modal__opener', 'no-js-hidden', 'quick-add-hidden');
                modal.dataset.modal = `#${this.parent.id}`;
                const modalButton = document.createElement('button');
                modalButton.innerText = 'Remove';
                modalButton.classList.add('link');
                modalButton.type = 'button';
                modal.appendChild(modalButton);
                priceWrapper.appendChild(modal);
                text.appendChild(title);
                text.appendChild(priceWrapper);
                const input = document.createElement('input');
                input.type = 'hidden';
                input.id = `xs-charm-${charm.dataset.productId}`;
                input.dataset.variantId = charm.dataset.variantId;
                input.dataset.productId = charm.dataset.productId;
                wrapper.appendChild(text);
                wrapper.appendChild(input);
                parentElement.appendChild(wrapper);
            });
        }
        this.closeButton.click();
    }

}

customElements.define('charm-popup', CharmPopup);

if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) {
                    this.submitButton.setAttribute('aria-haspopup', 'dialog');
                }

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') {
                    return;
                }

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                // config.headers['X-Requested-With'] = 'XMLHttpRequest';
                // delete config.headers['Content-Type'];

                const formData = new FormData(this.form);

                const mainItem = {};
                const items = [];
                const props = [];

                for (const keyval of formData.entries()) {
                    if (keyval[0].includes('properties[') && keyval[1].length > 0) {
                        const propKey = keyval[0].match(/\[(.*)\]/)[1];
                        const propVal = JSON.stringify(keyval[1]);
                        props.push(`"${propKey}": ${propVal}`);
                    }
                    else {
                        mainItem[keyval[0]] = keyval[1];
                    }
                }
                if (props.length > 0) {
                    const propVals = '{' + props.join() + '}';
                    mainItem['properties'] = JSON.parse(propVals);
                }
                items.push(mainItem);

                document.querySelectorAll('charms input[type="hidden"]').forEach(el => {
                    const charm = {
                        'id': el.dataset.variantId,
                        'quantity': 1,
                    };
                    items.push(charm);
                });
                const bodyItems = {};
                bodyItems.items = items;

                if (this.cart) {
                    bodyItems.sections = this.cart.getSectionsToRender().map((section) => section.id).toString();
                    bodyItems.sections_url = window.location.pathname;
                    this.cart.setActiveElement(document.activeElement);
                }

                config.body = JSON.stringify(bodyItems);

                fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) {
                            return;
                        }
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    }
                    else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    if (!this.error) {
                        console.log('Publishing event for cartUpdate', {response});
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response,
                        });
                    }
                    this.error = false;

                    document.getElementById('cart-notification-product').innerText = '';
                    response.items.forEach(addedItem => {
                        const cartNotificationObject = {};
                        cartNotificationObject.key = addedItem.key;
                        cartNotificationObject.sections = response.sections;
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener('modalClosed', () => {
                                setTimeout(() => { this.cart.renderContents(cartNotificationObject, true); });
                            }, {once: true});
                            quickAddModal.hide(true);
                        }
                        else {
                            console.log({cartNotificationObject});
                            this.cart.renderContents(cartNotificationObject, true);
                        }
                    });

                }).catch((e) => {
                    console.error(e);
                }).finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) {
                        this.cart.classList.remove('is-empty');
                    }
                    if (!this.error) {
                        this.submitButton.removeAttribute('aria-disabled');
                    }
                    this.querySelector('.loading__spinner').classList.add('hidden');
                });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) {
                    return;
                }

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) {
                    return;
                }
                this.errorMessage = this.errorMessage ||
                    this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}